// JsFromRoutes CacheKey 178f2fb19fd89426a414cbd93fa9e582
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  publicKey: /* #__PURE__ */ definePathHelper('get', '/push_subscriptions/public_key'),
  lookup: /* #__PURE__ */ definePathHelper('post', '/push_subscriptions/lookup'),
  change: /* #__PURE__ */ definePathHelper('post', '/push_subscriptions/change'),
  unsubscribe: /* #__PURE__ */ definePathHelper('post', '/push_subscriptions/unsubscribe'),
  test: /* #__PURE__ */ definePathHelper('post', '/push_subscriptions/test'),
  create: /* #__PURE__ */ definePathHelper('post', '/push_subscriptions'),
}
